import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const InsuranceService = () => {
  // Features data
  const features = [
    {
      icon: "⚡",
      title: "Instant Quotes",
      description:
        "Get quotes from 10+ leading insurers in seconds. Compare and choose the best policy.",
    },
    {
      icon: "🚗",
      title: "Two-Wheeler Insurance",
      description:
        "Comprehensive and third-party insurance for bikes and scooters at competitive rates.",
    },
    {
      icon: "🚙",
      title: "Four-Wheeler Insurance",
      description:
        "Coverage for cars, SUVs, and commercial vehicles. Private car and fleet policies available.",
    },
    {
      icon: "📄",
      title: "Instant Policy Issuance",
      description:
        "Once purchased, policy documents are generated instantly and sent to customer's email.",
    },
    {
      icon: "💰",
      title: "High Commissions",
      description:
        "Earn attractive commissions on every policy sold. Commission credited instantly.",
    },
    {
      icon: "🛡️",
      title: "POSP Model",
      description:
        "Work as a Point of Sales Person. Simple registration and no cerificate/exam required.",
    },
  ];

  // Insurance types
  const insuranceTypes = [
    { name: "Two-Wheeler Insurance", icon: "🛵" },
    { name: "Private Car Insurance", icon: "🚗" },
    { name: "Commercial Vehicle Insurance", icon: "🚛" },
    { name: "Third-Party Insurance", icon: "🛡️" },
    { name: "Comprehensive Insurance", icon: "📋" },
    { name: "Policy Renewals", icon: "🔄" },
  ];

  // Top insurers (for showcase)
  const insurers = [
    "Bajaj Allianz",
    "ICICI Lombard",
    "HDFC Ergo",
    "Digit",
    "United India",
    "SBI General",
    "TATA AIG",
  ];

  return (
    <React.Fragment>
      <Header variant="light" />
      <div className="service-page insurance-page">
        <Helmet>
          <title>Motor Insurance Service - Panmitra Online Services</title>
          <meta
            name="description"
            content="Offer two-wheeler and four-wheeler insurance through Panmitra. Instant quotes, multiple insurers, high commissions for agents. POSP model."
          />
        </Helmet>

        <div className="body-overlay"></div>

        <main>
          {/*===== HERO AREA STARTS =======*/}
          <div
            className="about-header-area"
            style={{
              backgroundImage: "url(assets/img/bg/inner-header.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-7 m-auto">
                  <div className="about-inner-header heading9 text-center">
                    <h1>Motor Insurance Service</h1>
                    <a href="/">
                      Home <i className="fa-solid fa-angle-right" />{" "}
                      <span>Insurance Service</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*===== SERVICE OVERVIEW =====*/}
          <section className="service-overview sp1">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-6">
                  <div className="overview-content heading2">
                    <h5>Motor Insurance (POSP)</h5>
                    <h2>Offer Motor Insurance Services to your customers</h2>
                    <p>
                      Panmitra offers a comprehensive motor insurance platform
                      for agents under the
                      <strong> POSP (Point of Sales Person)</strong> model. Sell
                      two-wheeler and four-wheeler insurance policies from top
                      insurers, earn high commissions, and provide value to your
                      customers. No certificate/exam required – just register
                      and start selling.
                    </p>
                    <ul className="feature-list">
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Compare quotes from 10+ insurers
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Instant policy issuance
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Attractive commissions (Instant Credited)
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        Easy POSP registration
                      </li>
                      <li>
                        <i className="fa-solid fa-circle-check text-primary"></i>{" "}
                        24x7 Customer support
                      </li>
                    </ul>
                    <div className="btn-area mt-4">
                      <a href="/contact-us" className="header-btn11">
                        Become a Insurance Agent{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="overview-image text-center">
                    <img
                      src="/images/insurance-banner.jpg"
                      alt="Insurance Illustration"
                      className="img-fluid rounded-4 shadow"
                      onError={(e) => (e.target.style.display = "none")}
                    />
                    {/* <div
                      className="fallback-icon"
                      style={{ fontSize: "10rem", color: "#dee2e6" }}
                    >
                      <i className="fa-solid fa-car"></i>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== KEY FEATURES =====*/}
          <section className="features-grid sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Why Agents Love Panmitra</h5>
                    <h2>Powerful Features for Insurance Agents</h2>
                    <p>
                      Everything you need to sell insurance policies
                      effortlessly.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-4 mt-4">
                {features.map((feature, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="feature-card">
                      <div className="feature-icon">{feature.icon}</div>
                      <h3>{feature.title}</h3>
                      <p>{feature.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== INSURANCE TYPES =====*/}
          <section className="service-types sp1">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>What We Offer</h5>
                    <h2>Complete Motor Insurance Solutions</h2>
                    <p>Coverage for all types of vehicles.</p>
                  </div>
                </div>
              </div>
              <div className="row g-3 mt-4 justify-content-center">
                {insuranceTypes.map((item, idx) => (
                  <div key={idx} className="col-lg-4 col-md-6">
                    <div className="type-card">
                      <span className="type-icon">{item.icon}</span>
                      <span className="type-name">{item.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== TRUSTED INSURERS =====*/}
          <section className="trusted-insurers sp2 bg2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Trusted Partners</h5>
                    <h2>We Work with Top Insurers</h2>
                    <p>
                      Your customers get the best coverage from India's leading
                      insurance companies.
                    </p>
                  </div>
                </div>
              </div>
              <div className="row g-3 mt-4 justify-content-center">
                {insurers.map((insurer, idx) => (
                  <div key={idx} className="col-lg-3 col-md-4 col-6">
                    <div className="insurer-card">{insurer}</div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/*===== HOW IT WORKS =====*/}
          <section className="how-it-works sp2">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="heading2">
                    <h5>Simple Process</h5>
                    <h2>How to Sell Insurance</h2>
                    <p>Three easy steps for agents</p>
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">1</div>
                    <h4>Register as POSP</h4>
                    <p>
                      Complete simple registration and become a certified POSP
                      agent with Panmitra.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">2</div>
                    <h4>Get Customer Details</h4>
                    <p>
                      Enter vehicle and customer information to fetch instant
                      quotes from multiple insurers.
                    </p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="step-card">
                    <div className="step-number">3</div>
                    <h4>Issue Policy & Earn</h4>
                    <p>
                      Select the best quote, complete payment, and issue policy
                      instantly. Commission credited automatically.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*===== CTA SECTION =====*/}
          <section
            className="cta5-section-area sp1"
            style={{
              backgroundImage: "url(assets/img/bg/header-bg5.png)",
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-8 m-auto text-center">
                  <div className="cta-content heading2">
                    <h2 className="text-white">
                      Ready to start earning with insurance?
                    </h2>
                    <p className="text-white">
                      Join Panmitra today and become a POSP agent. Offer the
                      best motor insurance policies to your customers.
                    </p>
                    <div className="btn-area mt-4 d-flex justify-content-center flex-wrap gap-3">
                      <a href="/contact-us" className="header-btn11">
                        Become a POSP Agent{" "}
                        <i className="fa-solid fa-arrow-right"></i>
                      </a>
                      <a
                        href="https://developers.instantpanmitra.com"
                        target="_blank"
                        className="header-btn10 text-white"
                      >
                        Explore APIs <i className="fa-solid fa-arrow-right" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
      <Footer hideCTA={true} />

      {/* Embedded CSS (extends the common styles with a few additions) */}
      <style>{`
        .service-page {
          overflow-x: hidden;
        }
        .service-overview {
          background-color: #fff;
        }
        .overview-content .feature-list {
          list-style: none;
          padding: 0;
          margin: 20px 0 0;
        }
        .overview-content .feature-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-bottom: 10px;
          font-size: 1rem;
          color: #334155;
        }
        .overview-content .feature-list i {
          color: #10b981;
          font-size: 1.3rem;
        }
        .features-grid {
          background-color: #f9fafc;
        }
        .feature-card {
          background: #fff;
          border-radius: 20px;
          padding: 30px 25px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          transition: transform 0.3s ease;
          height: 100%;
          text-align: center;
        }
        .feature-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .feature-icon {
          font-size: 3rem;
          margin-bottom: 20px;
        }
        .feature-card h3 {
          font-size: 1.4rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .feature-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .type-card {
          background: #fff;
          border-radius: 16px;
          padding: 20px 15px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          transition: all 0.2s ease;
          border: 1px solid #eef2f6;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 10px;
        }
        .type-card:hover {
          border-color: #f39c12;
          box-shadow: 0 8px 20px rgba(243,156,18,0.1);
        }
        .type-icon {
          font-size: 2.5rem;
        }
        .type-name {
          font-weight: 600;
          color: #1e293b;
          font-size: 1.1rem;
        }
        .trusted-insurers {
          background-color: #f9fafc;
        }
        .insurer-card {
          background: #fff;
          border-radius: 12px;
          padding: 15px;
          text-align: center;
          box-shadow: 0 5px 15px rgba(0,0,0,0.05);
          border: 1px solid #eef2f6;
          font-weight: 600;
          color: #1e293b;
          transition: all 0.2s ease;
        }
        .insurer-card:hover {
          border-color: #f39c12;
          box-shadow: 0 8px 20px rgba(243,156,18,0.1);
        }
        .step-card {
          text-align: center;
          padding: 30px 20px;
          background: #fff;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.05);
          height: 100%;
        }
        .step-number {
          width: 60px;
          height: 60px;
          background: #f39c12;
          color: #fff;
          font-size: 2rem;
          font-weight: 700;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px;
        }
        .step-card h4 {
          font-size: 1.3rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 15px;
        }
        .step-card p {
          color: #4b5563;
          line-height: 1.6;
        }
        .service-cta {
          background-color: #f8fafc;
          border-radius: 40px 40px 0 0;
        }
        .fallback-icon {
          opacity: 0.3;
        }
        .btn-area .header-btn10 {
          background: transparent;
          border: 2px solid #f39c12;
          color: #1e293b;
          padding: 12px 30px;
          border-radius: 50px;
          font-weight: 600;
          transition: all 0.3s ease;
          text-decoration: none;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }
        .btn-area .header-btn10:hover {
          background: #f39c12;
          color: #fff;
        }
        @media (max-width: 768px) {
          .feature-card, .step-card, .type-card, .insurer-card {
            padding: 20px;
          }
        }
      `}</style>
    </React.Fragment>
  );
};

export default InsuranceService;
